import * as React from 'react';

import * as styles from './SearchBlockContent.css';

interface ISearchBlockContentProps {
  searchInput: React.ReactNode;
  tips: React.ReactNode;
  suggests: React.ReactNode;
  isDesktop?: boolean;
}

export const SearchBlockContent: React.FC<ISearchBlockContentProps> = ({
  searchInput,
  tips,
  suggests,
  isDesktop = false,
}) => {
  return (
    <div className={isDesktop ? styles['desktop-container'] : styles['container']}>
      {searchInput && <div className={styles['search-input']}>{searchInput}</div>}
      <div className={styles['tips']}>{tips}</div>
      <div className={isDesktop ? styles['desktop-suggests'] : styles['suggests']}>{suggests}</div>
    </div>
  );
};
